import React from "react";

const DateRangeContext = React.createContext();

export default DateRangeContext;
